import { Component, Input, ViewEncapsulation, inject } from '@angular/core';
import { LimitedTimeEvent, LimitedTimeEventType } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { NavigationButtonComponent } from '../../navigation-button/navigation-button.component';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'slotcom-two-column-layout',
  templateUrl: './two-column-layout.component.html',
  styleUrls: ['./two-column-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NavigationButtonComponent, SharedModule],
})
export class TwoColumnLayoutComponent {
  private eventManager = inject(EventManager);
  logger = inject(LoggerService);

  @Input() event: LimitedTimeEvent;
  @Input() background: string;
  @Input() modalName: NonPersistedModalName;
  @Input() infoModal: NonPersistedModalName;
  @Input() showCloseButton: boolean = true;
  @Input() showInfoButton: boolean = true;

  LimitedTimeEventType = LimitedTimeEventType;

  openInfo(): void {
    this.eventManager.openModal(new Modal(this.infoModal, ModalType.View, this.event));
  }

  closeModal(): void {
    this.eventManager.closeModal(new Modal(this.modalName, ModalType.View, this.event));
  }
}
